<template>
  <div>
    <ModalAlert 
      :id="'modal-app-json-not-up-to-date'"
      :show="show" 
      :variant="'default'"
      :title="'Can\'t save your last edits.'"
      :hideFooter="true"
      :noCloseOnEsc="true"
      :noCloseOnBackdrop="true"
    >
      <template #description>
        <div class="fs-sa-16">พบปัญหาทางเทคนิค ส่งผลให้ไม่สามารถบันทึกเว็บไซต์ของคุณ เพื่อทำงานต่อเนื่องจากเวอร์ชั่นที่บันทึกล่าสุด โปรดรีเฟรชหน้าเพจนี้</div>
        <br/>
        <div class="d-flex justify-content-end">
          <b-button variant="blue" @click="onConfirm" class="mr-3">รีเฟรชหน้าเพจ</b-button
        >
        </div>
      </template>
    </ModalAlert>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ModalAlert from "@components_system/Shared/Tools/ModalAlert/ModalAlert";

export default {
  components: {
    ModalAlert,
  },
  computed: {
    ...mapGetters({
      languageEngine: "design/userPreference/languageEngine",
      synceError: "design/snapshot/synceError",
      synceResponse: "design/snapshot/synceResponse",
    }),
    show() {
      return this.synceError && (this.synceResponse.data.error === "ERROR_DESIGN_JSON_NOT_UP_TO_DATE") && false;
    },
    errorStatus() {
      return (this.synceError && this.synceResponse && this.synceResponse.status) || '';
    },
    errorMsg() {
      return (this.synceError && this.synceResponse && this.synceResponse.data.message) || '';
    }
  },
  methods: {
    onConfirm() {
      this.$store.dispatch("design/reload");
    },
  },
};
</script>